/* eslint-disable react/no-danger */
import React from 'react';
import at from 'lodash/at';
import styled, { withTheme } from 'styled-components';
import { validateInnerHtml } from '../../utils';
import { getCSSVariables } from '../../cruxComponents/utils';

const Text = styled.p`
  font: ${({ font }) => font?.[0]?.haveQuestions || font?.[1]?.haveQuestions};
  color: #2f3847;
  line-height: 24px;
`;

const Description = styled.p`
  font-family: 'AllstateSans-Regular';
  font-size: 18px;
  color: #2f3847;
  line-height: 24px;
`;

const HaveQuestionsWrapper = styled.div`
  ${({ layout, padding, maxWidth, width }) => `
        ${
          layout === 'single' &&
          `
            margin: 0 auto;
            max-width: ${
              maxWidth?.[0]?.['haveQuestions-haveQuestionsWrapper'] ||
              maxWidth?.[1]?.['haveQuestions-haveQuestionsWrapper']
            };
        `
        };
         ${layout === 'double' && 'margin: 20px 0'};
         ${width && `width: ${width}`};
        padding: ${
          padding?.[0]?.['haveQuestions-haveQuestionsWrapper'] ||
          padding?.[1]?.['haveQuestions-haveQuestionsWrapper']
        };
    `}
`;

const HaveQuestions = ({ layout, haveQuestions, theme, width }) => {
  // CSS Variables
  const cssVariables = getCSSVariables(theme);
  const font = at(cssVariables, ['pageOverride.font', 'global.font']);
  const padding = at(cssVariables, ['pageOverride.padding', 'global.padding']);
  const maxWidth = at(cssVariables, ['pageOverride.maxWidth', 'global.maxWidth']);

  if (!haveQuestions) return null;
  const { text, description } = haveQuestions;
  return (
    <HaveQuestionsWrapper layout={ layout } padding={ padding } width={ width } maxWidth={ maxWidth }>
      <Text font={ font }>{text}</Text>
      <Description>
        {/* nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml */}
        <p dangerouslySetInnerHTML={ { __html: validateInnerHtml(description) } } />
      </Description>
    </HaveQuestionsWrapper>
  );
};

export default withTheme(HaveQuestions);
